import { v4 as uuidv4 } from 'uuid';
import { getActiveSubscriptionsAPI } from './api';

async function getActiveSubscriptions() {
    const session = this.env.session;
    const traceId = this.env.traceId;

    this.startSubscriptionProgress();

    const res = await getActiveSubscriptionsAPI({
        store: this,
        token: session.token,
        traceId,
        page: this.page,
    });

    this.stopSubscriptionProgress();

    if (res.error) return;

    if (res?.data?.data?.results) {
        this.subscriptions = [
            ...this.subscriptions,
            ...res.data.data.results,
        ];

        this.pageInfo = {
            currentPage: res.data.data.currentPage,
            totalPages: res.data.data.totalPages,
            totalRecords: res.data.data.totalRecords,
            totalLoaded: (this?.pageInfo?.totalLoaded || 0) + res.data.data.results.length,
        };

        this.observed.subscriptions = uuidv4();
    }
}

export default getActiveSubscriptions;
